module.exports = __webpack_public_path__ + "static/media/Screenshot_2-thumb.d68cae2a.png";